import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const BiometricButton = ({ onAuthenticate, disabled }) => {
  const [isScanning, setIsScanning] = useState(false);

  const handleBiometricAuth = () => {
    if (disabled || isScanning) return;
    
    setIsScanning(true);
    
    setTimeout(() => {
      setIsScanning(false);
      if (onAuthenticate) {
        onAuthenticate();
      }
    }, 2000);
  };

  return (
    <button
      type="button"
      onClick={handleBiometricAuth}
      disabled={disabled || isScanning}
      className="w-full h-14 flex items-center justify-center gap-3 rounded-[12px] bg-muted text-foreground hover:bg-muted/80 transition-smooth disabled:opacity-50 disabled:cursor-not-allowed relative overflow-hidden group"
    >
      <div className={`absolute inset-0 bg-gradient-to-r from-primary/0 via-primary/10 to-primary/0 ${isScanning ? 'animate-shimmer' : 'opacity-0'}`} />
      
      <div className={`transition-smooth ${isScanning ? 'scale-110' : 'scale-100'}`}>
        <Icon 
          name="Fingerprint" 
          size={24} 
          color={isScanning ? 'var(--color-primary)' : 'currentColor'}
        />
      </div>
      
      <span className="text-base font-medium">
        {isScanning ? 'Scanning...' : 'Biometric Authentication'}
      </span>
      
      {isScanning && (
        <div className="absolute right-4">
          <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      )}
    </button>
  );
};

export default BiometricButton;